module.exports = __webpack_public_path__ + "static/media/PHONE-MOCKUP-1.606f59b5.png";